import {useDefault, useFirst} from '../../../common/common';
import {EarningsEstimate} from '../../model/reservation/points-estimate/earnings-estimate.model';

import {Earnings} from '../../model/reservation/points-estimate/earnings.model';
import {EarningsDetail} from '../../model/reservation/points-estimate/earnings-detail.model';

const POINTS_EARNING_TYPE = 'HPC';

export class PointsEstimateBuilder {
  private _model: EarningsEstimate;

  constructor() {
    this._model = new EarningsEstimate();
  }


  withPointsEstimateData(pointsEstimateInfo: any): PointsEstimateBuilder {
    const pointsEstimateData = useDefault(pointsEstimateInfo, {});
    this._setPointsEstimate(pointsEstimateData.estimations);
    return this;
  }


  private _setPointsEstimate(estimatesData: Array<any>) {
    if (!estimatesData){
      return
    }
    const estimateData = useFirst(estimatesData, {});
    const pointsAndMiles = Object.assign(estimateData.unitInfos);
    const totalPointsAndMiles = pointsAndMiles.pop();

    let pointsTotalEarnings: EarningsDetail = null;
    let milesTotalEarnings: EarningsDetail = null;
    const pointsOtherEarnings: Array<EarningsDetail> = new Array<EarningsDetail>();
    const milesOtherEarnings: Array<EarningsDetail> = new Array<EarningsDetail>();
    for (const unitData of useDefault(totalPointsAndMiles.units, [])) {
      const earningsDetail = new EarningsDetail(totalPointsAndMiles.name, unitData.unitType, unitData.unitName, unitData.amount);
        if (earningsDetail.type === POINTS_EARNING_TYPE) {
          pointsTotalEarnings = earningsDetail;
        } else {
          milesTotalEarnings = earningsDetail;
        }
    }
    for (const estimateData of useDefault(pointsAndMiles, [])) {
      for (const unitData of useDefault(estimateData.units, [])) {
        const earningsDetail = new EarningsDetail(estimateData.name, unitData.unitType, unitData.unitName, unitData.amount);
        if (earningsDetail.type === POINTS_EARNING_TYPE) {
          pointsOtherEarnings.push(earningsDetail);
        } else {
          milesOtherEarnings.push(earningsDetail);
        }
      }
    }


    if (pointsTotalEarnings && pointsTotalEarnings.amount) {
      this._model.points = new Earnings(pointsTotalEarnings, pointsOtherEarnings);
    }
    if (milesTotalEarnings && milesTotalEarnings.amount) {
      this._model.miles = new Earnings(milesTotalEarnings, milesOtherEarnings);
    }
  }

  build(): EarningsEstimate {
    return this._model;
  }


}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/builders/points-estimate.model.builder.ts